import React from 'react';
import LabelSection from 'components/sections/LabelSection';
import styles from './TransferDetail.css';

const mapTransferDetailData = historyDetails => {
  const ingredientUnitIds = [];
  const groupedIngredients = [];
  historyDetails.forEach(hd => {
    if (!ingredientUnitIds.includes(hd.unit_id)) {
      ingredientUnitIds.push(hd.unit_id);
      groupedIngredients.push({
        unit_id: hd.unit_id,
        unit_name: hd.unit_name,
        total: 0,
        ingredientHistoryDetails: [],
      });
    }

    groupedIngredients.forEach(ing => {
      if (ing.unit_id === hd.unit_id) {
        ing.ingredientHistoryDetails.push(hd);
        ing.total = ing.total + hd.quantity;
      }
    });
  });
  return groupedIngredients.sort(function(a, b) {
    return (a.unit_name > b.unit_name) - (a.unit_name < b.unit_name);
  });
};

export default class IngredientTransferStock extends React.Component {
  render() {
    const { transferDetail } = this.props;

    return (
      transferDetail && (
        <div>
          <div className="row mt-40px mb-5px ml-0px mr-0px">
            <div className="col-sm-5 pl-0px" />
          </div>
          <LabelSection title="transfer stock table" />
          {mapTransferDetailData(transferDetail.history_details).map(
            (ing, idx) => {
              return (
                <div key={idx}>
                  {ing.ingredientHistoryDetails.map((ihd, index) => {
                    return (
                      <div key={index}>
                        <div className="row">
                          <div className="col-sm-9 ml-5px ">
                            <div>{ihd.ingredient_name}</div>
                          </div>
                          <div
                            className={`col-sm-3 pl-0px ${
                              styles['variant-quantity']
                            }`}
                          >
                            <div>
                              {transferDetail.is_sender
                                ? -ihd.quantity
                                : ihd.quantity}
                              {` ${ihd.unit_name}`}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className={styles['separator-row']} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="row mb-30px">
                    <div className={`col-sm-8 ${styles['label-total']}`}>
                      TOTAL
                    </div>
                    <div className={`col-sm-4 ${styles['total-ing-trf']}`}>
                      {transferDetail.is_sender ? -ing.total : ing.total}
                      {` ${ing.unit_name}`}
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>
      )
    );
  }
}
